import * as React from "react";
export var ProgressBar = function (_a) {
    var progressPercent = _a.progressPercent, children = _a.children, backgroundClassName = _a.backgroundClassName, fillClassName = _a.fillClassName, className = _a.className;
    var actualProgress = progressPercent > 100 ? 100 : progressPercent;
    var widthPercentStyle = {
        width: actualProgress + "% ",
    };
    return (React.createElement("div", { className: "progress-bar " + (className || "") },
        React.createElement("div", { className: "progress-bar--background " + backgroundClassName },
            React.createElement("div", { className: "progress-bar--fill " + fillClassName, style: widthPercentStyle }),
            React.createElement("div", { className: "progress-bar--bar-content" }, children))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/progress-bar/ProgressBar.tsx
// module id = 429
// module chunks = 3